//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Detail from "./components/Detail.vue";
export default {
    name: "App",
    props: {
        doc: {
            type: Object,
            required: true,
        },
        is_new: {
            type: Boolean,
            required: true,
        },
    },
    components: {
        Detail,
    },
    // computed: {
    // 	doc() {
    // 		return this.doc;
    // 	}
    // }
};
